import { useState } from "react"
import { Text, Button } from "../../../components"
import { copyToClipboard } from "../../crm/api"
import { Modal } from "./modal"
// стили модалки лежат в общем файле админки — подключаем, чтобы работало и вне неё
import '../style.css'

const SUPPORT_EMAIL = 'v79740240@gmail.com'
const SUPPORT_TELEGRAM_URL = 'https://t.me/vapira_vlink?direct'

interface SupportModalProps {
    onClose: () => void;
    showText?: boolean;
    // готовый текст первого сообщения — показываем вместо подсказки, чтобы его можно было скопировать
    message?: string;
}

const MessageField = ({message}: {message: string}) => {
    const [isCopied, setIsCopied] = useState(false)

    const handleCopy = () => {
        copyToClipboard(message)
            .then(() => setIsCopied(true))
            .catch(() => setIsCopied(false))
    }

    return (
        <div className="support-message">
            <Text size="xs" color="lightGray">Можете скопировать сообщение и отправить нам</Text>
            <div className="support-message-field">
                <span className="support-message-text">{message}</span>
                <button
                    type="button"
                    className={`support-message-copy${isCopied ? ' is-copied' : ''}`}
                    aria-label={isCopied ? 'Скопировано' : 'Скопировать'}
                    title={isCopied ? 'Скопировано' : 'Скопировать'}
                    onClick={handleCopy}
                >
                    {isCopied ? (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12.5l4.5 4.5L19 7.5" />
                        </svg>
                    ) : (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                            <path d="M20 13.1251L20 6.00003C20 4.34317 18.6568 3.00002 17 3.00004L9.875 3.00012M14 21.0001L7.25 21.0001C6.00736 21.0001 5 19.9928 5 18.7501L5 9.00012C5 7.75748 6.00736 6.75012 7.25 6.75012L14 6.75012C15.2426 6.75011 16.25 7.75748 16.25 9.00012L16.25 18.7501C16.25 19.9928 15.2426 21.0001 14 21.0001Z" />
                        </svg>
                    )}
                </button>
            </div>
        </div>
    )
}

export const SupportModal = ({onClose, showText = true, message}: SupportModalProps) => (
    <Modal title={showText ? "Поддержка" : 'Контакты'} onClose={onClose}>
        {message ? <MessageField message={message} /> : showText ?
            <Text size="s" color="lightGray">Если что-то не работает или есть вопрос — напишите нам, ответим как можно скорее</Text> :
            <Text size="s" color="lightGray">Напишите нам и мы проконсультируем вас для дальнейшей покупки</Text>
            }
        <Button type="button" variant="solid" fullWidth textSize="s" onClick={() => window.open(SUPPORT_TELEGRAM_URL, '_blank', 'noopener,noreferrer')}>Написать в Telegram</Button>
        <Button type="button" variant="outline" fullWidth textSize="s" onClick={() => window.location.assign(`mailto:${SUPPORT_EMAIL}`)}>Написать на почту</Button>
        <Text size="xs" color="lightGray">{SUPPORT_EMAIL}</Text>
    </Modal>
)
